export const currencyCookieName = "currency";
